import { Fragment } from 'react';

import { Dialog, Transition } from '@headlessui/react';

import useSubscribeRecommendations from '~/hooks/useSubscribeRecommendations';
import RecommendationsForm from '~/pages/recommendations/components/RecommendationsForm';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children?: React.ReactElement<any> | number | string;
}

// biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility
const RecommendationsModal = ({ isOpen, onClose, children }: ModalProps) => {
  const { isLoading, recommendations, boostedRecommendations } = useSubscribeRecommendations();

  const hasData = recommendations.length > 0 || boostedRecommendations.length > 0;
  const shouldShowModal = Boolean(isOpen && !isLoading && hasData);

  return (
    <Transition appear show={shouldShowModal} as={Fragment}>
      <Dialog as="div" className="relative" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 z-20 bg-black/60" />
        </Transition.Child>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
          enterTo="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 translate-y-0 sm:scale-100"
          leaveTo="opacity-0 translate-y-full sm:translate-y-0 sm:scale-95"
        >
          <div className="fixed inset-0 z-20 flex items-end justify-center p-0 pt-16 sm:inset-4 sm:items-center sm:p-4">
            <div className="h-auto max-h-full w-full overflow-auto rounded-t-2xl bg-white shadow-xl sm:h-auto sm:max-h-[90vh] sm:max-w-2xl sm:rounded-md">
              <Dialog.Panel className="h-auto w-full">
                <RecommendationsForm
                  isLoading={isLoading}
                  recommendations={recommendations}
                  boostedRecommendations={boostedRecommendations}
                />
              </Dialog.Panel>
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition>
  );
};

export default RecommendationsModal;
